<template>
  <div id="app" :class="appClasses">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import '@/css/main.scss'
import '@/css/theme.scss'

export default {
  name: "App",
  computed: {
    appClasses () {
      const designType = this.$store.getters.domainConfig?.designType || 1;
      const themeClass = designType === 2 ? 'theme-orange' : '';
      const deviceType = this.$store.getters.deviceType;
      const deviceClass = deviceType === 'mobile' || deviceType === 'tablet' ? 'is_mobile i_m' : 'is_pc i_pc';
      return `${deviceClass} ${themeClass}`;
    }
  },
  created () {
    // 调试模式检测
    const debug = this.$global.GetQueryString('db');
    if (debug) {
      this.$store.commit('setDebug', true);
    }

    // 设备类型检测和存储
    const deviceType = this.detectDeviceType();
    this.$store.commit('setDeviceType', deviceType);

  },
  mounted () {
    this.fetchGlossary();
    this.fetchSubprimeLendingInstitutions();
  },
  methods: {
    fetchGlossary () {
      this.$global.server.postAPI({
        method: 'get',
        params: {
          pageSize: '50',
          pageNum: '1',
        },
        url: '/car/Loans/indexPage',
      })
        .then(response => {
          if (response && response.data && response.data.list) {
            // 将接口返回的贷款机构列表存储到vuex
            this.$store.commit('setGlossary', response.data.list);
            console.log('汽车贷款机构列表获取成功:', response.data);
          }
        })
        .catch(error => {
          console.error('获取汽车贷款机构列表失败:', error);
        });
    },
    fetchSubprimeLendingInstitutions () {
      this.$global.server.postAPI({
        method: 'get',
        params: {
          pageSize: '20',
          pageNum: '1',
        },
        url: '/car/Loans/subprimeLendingInstitutionsList',
      })
        .then(response => {
          if (response && response.data) {
            // 将接口返回的信用较差贷款机构列表存储到vuex
            this.$store.commit('setSubprimeLendingInstitutions', response.data);
            console.log('信用较差贷款机构列表获取成功:', response.data);
          }
        })
        .catch(error => {
          console.error('获取信用较差贷款机构列表失败:', error);
        });
    },
    detectDeviceType () {
      try {
        // SSR 环境检测
        if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
          return this.$ssrContext.device;
        }

        // 客户端环境检测
        if (typeof window !== 'undefined') {
          const userAgent = navigator.userAgent.toLowerCase();

          // 平板设备检测
          const isTablet = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
          if (isTablet) return 'tablet';

          // 移动设备检测
          const isMobile = /mobile|android|iphone|phone|webos|ipod|blackberry|windows phone/i.test(userAgent);
          if (isMobile) return 'mobile';

        }

        return 'desktop';
      } catch (error) {
        console.warn('设备类型检测失败:', error);
        return 'desktop'; // 发生错误时返回默认值
      }
    },

  }
};
</script>
